import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import axios from 'axios';
// components
import VueReactionButton from '@/vue/components/VueReactionButton.vue';
// types
import type { ReactionType } from '@/ts/public/type/ReactionType';


interface ReactionButtonList {
  type: string;
  icon: string;
  label: string;
  color: string;
}

// const reactionIcons: Record<string, string> = {
//   participated: 'how_to_reg',
//   interested: 'distance',
//   support: 'campaign',
// };


export default /*@__PURE__*/_defineComponent({
  __name: 'VueProjectReaction',
  props: {
    projectId: { type: Number, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const baseUrl = (window as any).baseUrl ?? '';

const isSubmitting = ref<boolean>(false);

// リアクションボタンの型
const reactionButtons = ref<ReactionButtonList[]>([]);

const reactionData = ref<{
  counts: {
    participated: number;
    interested: number;
    support: number;
  };
  my_reaction_type: string | null;
} | null>(null);

// 親からプロジェクトIDを受け取る
const props = __props;


onMounted(async () => {
  const response = await axios.get(`${baseUrl}/reaction/${props.projectId}`);
  const data = response.data;
  // console.log(data);
  reactionButtons.value = data.types.map((reactionOption: ReactionButtonList) => ({
    type: reactionOption.type,
    icon: reactionOption.icon,
    label: reactionOption.label,
    color: reactionOption.color,
  }));

  console.log(reactionButtons.value);

  reactionData.value = data;
});

const toggleReaction = async (type: ReactionType['type']) => {
  // console.log(type);
  if (!reactionData.value || isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    const response = await axios.post(`${baseUrl}/reaction/${props.projectId}`, {
      reaction_type: type,
    })
    reactionData.value = response.data;
    // console.log(reactionData.value);
  } catch (error) {
    console.error(error);
  } finally {
    isSubmitting.value = false;
  }
}



const __returned__ = { baseUrl, isSubmitting, reactionButtons, reactionData, props, toggleReaction, ref, onMounted, get axios() { return axios }, VueReactionButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})